import { UNSAFE_PortalProvider as PortalProvider } from "react-aria";
import { type PopoverProps as PopoverPrimitiveProps } from "react-aria-components";
import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "./Popover.styled";
import { MAX_LIST_HEIGHT } from "../SelectV2.constants";
import { useOverlay } from "../../OverlayContext";

export type PopoverProps = PopoverPrimitiveProps & {
  width?: number;
};

function Popover(props: PopoverProps) {
  const { width, ...otherProps } = props;

  const { tokens } = useDesignTokens();
  const { select: selectTokens } = tokens;

  const { portalElement } = useOverlay();

  return (
    <PortalProvider getContainer={portalElement && (() => portalElement)}>
      <S.Popover
        $width={width}
        maxHeight={MAX_LIST_HEIGHT}
        offset={parseInt(selectTokens.gap, 10)}
        {...otherProps}
      />
    </PortalProvider>
  );
}

export default Popover;
